module.exports = __webpack_public_path__ + "media/images/lb/896-bfce3c3abe03b63ca7cf00418b4f3b66.svg";